module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Foamcore_MockedUp.f1c61607.jpg";